import React from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { Row, Column, TextField, Button, Checkbox, Spacing } from 'quantic'
import { Social, LineWithText, Title, ActionLink } from '../styles'

function Authentication(props) {
  const { onSubmitLogin } = props
  const { handleSubmit, register, errors, formState } = useForm()

  const { push } = useHistory()

  return (
    <>
      <form onSubmit={handleSubmit(onSubmitLogin)}>
        <Row>
          <Column size={12}>
            <Title>Bem-vindo</Title>
          </Column>
          <Column size={12}>
            <TextField
              name="email"
              label="E-mail"
              fullWidth
              ref={register({
                required: 'Campo obrigatório',
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: 'Formato de e-mail inválido',
                },
              })}
              error={errors.email?.message}
            />
          </Column>
          <Column size={12}>
            <TextField
              name="password"
              label="Senha"
              type="password"
              fullWidth
              ref={register({
                required: 'Campo obrigatório',
              })}
              error={errors.password?.message}
            />
          </Column>
          <Column justifyContent="space-between" size={12}>
            <div style={{ display: 'flex' }}>
              <Checkbox name="rememberPassword" onChange={() => {}} />
              Lembrar minha senha
            </div>
            <ActionLink onClick={() => push('/recuperar-senha')}>Esqueceu sua senha?</ActionLink>
          </Column>
          <Spacing size="md" />
          <Column justifyContent="flex-end" size={12}>
            <Button loading={formState.isSubmitting} primary type="submit" fullWidth>
              Entrar
            </Button>
          </Column>
        </Row>
        <Row>
          <Column size={12}>
            <LineWithText>
              <span>Ou entre com</span>
            </LineWithText>
          </Column>
          <Column size={12}>
            <Social>
              <div size={4}>
                <img src="/assets/svg/facebook.svg" alt="Ícone do Facebook" />
              </div>
              <div size={4}>
                <img src="/assets/svg/linkedin.svg" alt="Ícone do Linkedin" />
              </div>
              <div size={4}>
                <img src="/assets/svg/instagram.svg" alt="Ícone do instagram" />
              </div>
            </Social>
          </Column>
        </Row>
      </form>
      <Spacing size="sm" />
      <Row>
        <Column justifyContent="space-around" size={12}>
          <ActionLink onClick={() => push('/validar-conta')}>Confirmar código</ActionLink>
          <ActionLink onClick={() => push('/validar-certificado')}>Validar Certificado</ActionLink>
        </Column>
      </Row>
    </>
  )
}

Authentication.propTypes = {
  onSubmitLogin: PropTypes.func.isRequired,
}

export default Authentication
